// Template Layout
import QRCheckin from "@/components/QRCheckin";
import ManagementLayout from "./ManagementLayout";

// Routes
import { userRoutes } from "./modules/users/routes";
import { projectRoutes } from "./modules/projects/routes";
import { messagingRoutes } from "./modules/messaging/routes";
import { lineNotifyRoute } from "./modules/line-notify/routes"

// Components

export const managementRoutes = {
  path: "management",
  component: ManagementLayout,
  children: [
    {
      path: "qrcheckin",
      name: "QRCheckin",
      component: QRCheckin
    },
    ...userRoutes(),
    ...projectRoutes(),
    ...messagingRoutes(),
    lineNotifyRoute
  ]
};
